"use client";
import { IconCar, IconTrendingUp } from "@tabler/icons-react";
import { BarChart3, Loader2 } from "lucide-react";

export default function LoadingPage() {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50 animate-in fade-in duration-300">
      <div className="flex flex-col items-center gap-6">
        <div className="relative">
          <div
            className="absolute inset-0 rounded-full animate-pulse"
            style={{
              backgroundColor: "#00d97e",
              opacity: 0.1,
              transform: "scale(1.5)",
            }}
          />
          <div
            className="relative rounded-full p-6"
            style={{ backgroundColor: "#00d97e" }}
          >
            <IconCar className="h-12 w-12 text-white" />
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <h1 className="text-2xl tracking-tight text-black">
            Car<span style={{ color: "#00d97e" }}>Tracked</span>
          </h1>
        </div>

        <div className="flex items-center gap-2 mt-2">
          <Loader2
            className="h-5 w-5 animate-spin"
            style={{ color: "#00d97e" }}
          />
          <p className="text-sm text-gray-600">Warming up...</p>
        </div>

        <div className="flex gap-2">
          <div
            className="h-2 w-2 rounded-full animate-pulse"
            style={{ backgroundColor: "#00d97e", animationDelay: "0ms" }}
          />
          <div
            className="h-2 w-2 rounded-full animate-pulse"
            style={{ backgroundColor: "#00d97e", animationDelay: "150ms" }}
          />
          <div
            className="h-2 w-2 rounded-full animate-pulse"
            style={{ backgroundColor: "#00d97e", animationDelay: "300ms" }}
          />
        </div>

        <div className="flex items-center gap-8 mt-8 opacity-30">
          <BarChart3
            className="h-6 w-6 text-gray-400 animate-pulse"
            style={{ animationDelay: "0ms" }}
          />
          <IconTrendingUp
            className="h-6 w-6 text-gray-400 animate-pulse"
            style={{ animationDelay: "200ms" }}
          />
          <IconCar
            className="h-6 w-6 text-gray-400 animate-pulse"
            style={{ animationDelay: "400ms" }}
          />
        </div>
      </div>
    </div>
  );
}
